











 












const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MostUsedEmojisCard_insights",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamInsightsCard_insights"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Emoji",
      "kind": "LinkedField",
      "name": "mostUsedEmojis",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamInsights",
  "abstractKey": null
};

(node ).hash = "118967de3c4153b215b3d1478ee297e4";

export default node;
